import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import route from '../../../vendor/tightenco/ziggy/src/js/route';

export default class CookieBar extends Component {
    constructor() {
        super();
        const hasNotSeen =
            JSON.parse(localStorage.getItem('hasNotSeen')) === null
                ? true
                : JSON.parse(localStorage.getItem('hasNotSeen'));

        this.state = { hasNotSeen };
    }

    close = () => {
        this.setState({ hasNotSeen: false });
        localStorage.setItem('hasNotSeen', JSON.stringify(false));
    };

    render() {
        if (this.state.hasNotSeen === false) {
            return null;
        }
        return (
            <div className="alert alert-dismissible cookiealert fade show" role="alert">
                <div className="cookiealert-container">
                    &#x1F36A; We use cookies to ensure you get the best experience on our website.
                    <a href={route('cookies')} className="mr-3">
                        {' '}
                        Learn more
                    </a>
                    <button
                        onClick={this.close}
                        type="button"
                        className="btn btn-primary close_btn"
                        aria-label="Close"
                    >
                        <span>Got it</span>
                    </button>
                </div>
            </div>
        );
    }
}

if (document.getElementById('cookie-bar')) {
    ReactDOM.render(<CookieBar />, document.getElementById('cookie-bar'));
}
